// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"Sidebar_Sidebar__2Vey6","sidebarOpen":"Sidebar_sidebarOpen__1pJGE","spindindust":"Sidebar_spindindust__2WO0c"};